import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'sliceArray'
})
export class SliceArrayPipe implements PipeTransform {

  transform(value: unknown, from: number, to?: number): any[] {
    if (Array.isArray(value)) {
      if (to) {
        return value.slice(from, to);
      } else {
        return value.slice(from);
      }
    }
    return [];
  }

}
